import { _get, _post, _delete } from "../../http";
const menu = {
  get: (data) => _get("admin/dict/getDictListByType", data), //字典表查询
  getType: (data) => _post("admin/dict/getDictTypeList", data), //字典类型表查询
  add: (data) => _post("admin/dict/saveDictInfo", data), //新增或更新标签
  update: (data) => _post("admin/dict/saveDictInfo", data), //新增或更新标签
  delete: (data) => _post("admin/dict/removeDictInfo", data), //删除标签
};
export default menu;
